import _template from 'lodash/template';

// eslint-disable-next-line import/prefer-default-export
export const maxCharactersTemplate = (locale, max) =>
  _template(locale['validation.maxNCharacters'])({ max });
